import {getApi, clearCache} from 'modules/api';
import endpoints from 'config/endpoints';
import {INIT_INDEX} from 'util/constants';
import {routerActions} from 'react-router-redux';


export const impersonateUser = userId => (dispatch, getState) => {
    dispatch(startProcess());
    getApi().post(endpoints.impersonateUser.endpoint, {'impersonate-user': userId})
        .then(response => {
            getApi().get(endpoints.whoami.endpoint)
                .then(json => {
                    dispatch(clearCache());
                    dispatch({type: 'WHOAMI_SUCCESS', user: json.results[INIT_INDEX]});
                    dispatch(routerActions.push('/'));
                    dispatch(finishProcess(response.hash, json.results[INIT_INDEX]));
                })
                .catch(_error => dispatch(finishProcess()));
        })
        .catch(_error => dispatch(finishProcess()));
};

export const unimpersonateUser = () => (dispatch, getState) => {
    dispatch(startProcess());
    getApi().put(`${endpoints.impersonateUser.endpoint}${getState().impersonateUser.hash}`)
        .then(response => {
            getApi().get(endpoints.whoami.endpoint)
                .then(json => {
                    dispatch(clearCache());
                    dispatch({type: 'WHOAMI_SUCCESS', user: json.results[INIT_INDEX]});
                    dispatch(routerActions.push('/'));
                    dispatch(finishProcess());
                })
                .catch(_error => dispatch(finishProcess()));
        })
        .catch(_error => dispatch(finishProcess()));
};

const IMPERSONTE_USER_START_PROCESS = 'IMPERSONTE_USER_START_PROCESS';

export const startProcess = () => ({
    type: IMPERSONTE_USER_START_PROCESS
});

const IMPERSONTE_USER_FINISH_PROCESS = 'IMPERSONTE_USER_FINISH_PROCESS';

export const finishProcess = (hash, whoami) => ({
    type: IMPERSONTE_USER_FINISH_PROCESS,
    hash, whoami
});

const _defaultState = () => ({
    isLoading: false,
    hash:      undefined,
    whoami:    undefined
});

export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case IMPERSONTE_USER_START_PROCESS:
        return {
            ...state,
            isLoading: true
        };
    case IMPERSONTE_USER_FINISH_PROCESS:
        return {
            isLoading: false,
            hash:      action.hash,
            whoami:    action.whoami
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/impersonateUser.js